import Vue from 'vue';
import Vuex from 'vuex';
import vuexModules from './modules/dic.js'

Vue.use(Vuex);
export default new Vuex.Store({
  modules: vuexModules
})